import { SectionCard } from "@/base/parts";
import { useStepHold } from "@/base/wizard/stepHold";
import { useProgress } from "@/components/TopProgress";

// A step that's reading from PMS (BRK-S368; Nav, 2026-10-16: "we should
// display a progress instead of text message on the background color
// screen"): a white card in the step card's shape with placeholder fields
// where the form will be, flashing so it never looks blank, as a list's first
// load shows skeleton rows (BRK-S211) and the notifications panel its
// placeholder lines. The words are the status a screen reader hears; on
// screen the card says it. Inside a card that's already there,
// `framed={false}` drops the card. Under reduced motion the placeholders hold
// still.
//
// The progress bar is the submission's ONE global bar along the top navbar
// (BRK-S488; Nav, 2026-10-28), which a placeholder runs while it's there:
// however many wait, one bar, never one in each card. A step draws its form
// only once everything it needs is in, so a placeholder stands for the whole
// step rather than filling in a part at a time. While it's there it also holds
// the step, so the wizard's primary button waits (BRK-S492).

const PLACEHOLDER = "block bg-brk-bg motion-safe:animate-pulse";

export function StepLoading({
  label,
  framed = true,
}: {
  label: string;
  framed?: boolean;
}) {
  useProgress(true);
  useStepHold(true);
  const body = (
    <div aria-busy="true" data-step-loading className="flex flex-col gap-4">
      <p role="status" className="sr-only">
        {label}
      </p>
      <div aria-hidden="true" className="flex flex-col gap-4">
        <span className={`${PLACEHOLDER} h-4 w-1/3 rounded`} />
        <div className="grid gap-4 md:grid-cols-2">
          {[0, 1, 2, 3].map((i) => (
            <span
              key={i}
              data-step-loading-field
              className="flex flex-col gap-1.5"
            >
              <span className={`${PLACEHOLDER} h-3 w-1/4 rounded`} />
              <span className={`${PLACEHOLDER} h-10 rounded-md`} />
            </span>
          ))}
        </div>
      </div>
    </div>
  );
  return framed ? <SectionCard>{body}</SectionCard> : body;
}
